import { BreakPointCondition, useBreakpointIf } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback } from 'react';

import { FilterModal } from '../../../../../../components/FilterModal';
import { batchTicketCustomerFilterState } from '../../../../../../store/batchTicket/atom';

export const BatchTicketCustomerModalFilter = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <FilterModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      filterAtom={batchTicketCustomerFilterState}
    />
  );
};
